import TopSection from "../../LT/TopSection";

const ARDashboard = () => {
    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Dashboard" },
                ]}
                tabTitle="Dashboard"
            />
        </div>
    )
}

export default ARDashboard;